import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./global.css";

// Verify React is loaded
if (!React) {
  throw new Error("React module failed to load");
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
